// Pure decision logic behind the receipt detail page's evidence
// panel. Extracted from ReceiptDetailPage so it can be unit tested
// without a React rendering harness (the dashboard has none today;
// see the TODO in ReceiptDetailPage.tsx). The component calls these
// same functions, so the tests pin the behavior the UI depends on.

import type { ReceiptEnvelope } from "../api/client";
import { sha256HexOfBytes } from "../api/client";

type EvidenceReference = ReceiptEnvelope["evidence_references"][number];

// Whether the dashboard should offer to fetch and render evidence
// content for this reference. Only sequesign_hosted evidence lives at
// Sequesign and is fetchable; external_client_managed evidence shows
// an explanatory note and no fetch affordance.
export function evidenceIsFetchable(ref: EvidenceReference): boolean {
  return ref.evidence_custody === "sequesign_hosted";
}

export type EvidenceVerification = {
  verified: boolean;
  computedHash: string;
};

// Re-hashes the fetched evidence bytes and compares against the
// envelope's recorded evidence_hash. The intermediary stores evidence
// as canonical bytes and evidence_hash is sha256 over those bytes, so
// a plain sha256 over the fetched bytes reproduces evidence_hash when
// the content is intact.
export async function verifyEvidenceBytes(
  bytes: Uint8Array,
  expectedHash: string
): Promise<EvidenceVerification> {
  const computedHash = await sha256HexOfBytes(bytes);
  return { verified: computedHash === expectedHash, computedHash };
}
